import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { CheckboxFieldProps } from "types";

const CheckboxField = ({ id, label, checked, onChange, disabled }: CheckboxFieldProps) => (
  <FormControlLabel
    sx={{ mb: "1rem", "& .MuiFormControlLabel-label": { userSelect: "none" } }}
    control={<Checkbox id={id} checked={checked} onChange={onChange} disabled={disabled} color="primary" />}
    label={label}
  />
);

export default CheckboxField;
